export const EXPAND_KEY = "_expandRow";
